define(["exports", "@babel/runtime/helpers/esm/extends", "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose", "react", "styled-components", "lodash", "polished", "react-window", "../../themes", "../../utils", "./Row"], function (_exports, _extends2, _objectWithoutPropertiesLoose2, _react, _styledComponents, _lodash, _polished, _reactWindow, _themes, _utils, _Row) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

  var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.TagInput = void 0;
  _extends2 = _interopRequireDefault(_extends2);
  _objectWithoutPropertiesLoose2 = _interopRequireDefault(_objectWithoutPropertiesLoose2);
  _react = _interopRequireWildcard(_react);
  _styledComponents = _interopRequireDefault(_styledComponents);
  _Row = _interopRequireDefault(_Row);
  var _excluded = ["activeOnBlur", "onEditing", "delimiters", "onDelete", "name", "placeholder", "icon", "items", "maxLength", "handleAddition", "fetchSuggestions", "ariaLabel", "loadingMessage", "noResultsMessage", "onlyAcceptSuggestion", "error"];
  var KEYS = {
    ENTER: 13,
    COMMA: 188,
    SEMICOLON: 186 || 59,
    DOWN: 40,
    UP: 38,
    DELETE: 8
  };

  var Wrap = _styledComponents.default.div.withConfig({
    displayName: "TagInput__Wrap",
    componentId: "sc-48blzg-0"
  })(["position:relative;"]);

  var WrapInput = _styledComponents.default.label.withConfig({
    displayName: "TagInput__WrapInput",
    componentId: "sc-48blzg-1"
  })(["align-items:center;background-color:", ";border:1px solid ", ";border-radius:2px;display:flex;height:40px;overflow:hidden;padding:", ";position:relative;transition:box-shadow 0.4s ", ";width:100%;> box-icon{display:block;fill:", ";height:18px;left:16px;position:absolute;width:18px;}&:focus-within{border:solid 1px ", ";box-shadow:0 0 3px 0 ", ";}"], function (_ref) {
    var theme = _ref.theme;
    return theme.colors.white;
  }, function (_ref2) {
    var theme = _ref2.theme,
        error = _ref2.error;
    return error ? theme.colors.red : theme.colors.gray;
  }, function (_ref3) {
    var icon = _ref3.icon;
    return icon ? '8px 8px 8px 40px' : '8px';
  }, function (_ref4) {
    var theme = _ref4.theme;
    return theme.easing.ease;
  }, function (_ref5) {
    var theme = _ref5.theme;
    return theme.colors.dark;
  }, function (_ref6) {
    var theme = _ref6.theme,
        error = _ref6.error;
    return error ? theme.colors.red : theme.colors.blue;
  }, function (_ref7) {
    var theme = _ref7.theme,
        error = _ref7.error;
    return error ? theme.colors.red : theme.colors.blue;
  });

  var ScrollContent = _styledComponents.default.div.withConfig({
    displayName: "TagInput__ScrollContent",
    componentId: "sc-48blzg-2"
  })(["align-items:center;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;display:flex;overflow-x:auto;scrollbar-width:none;width:100%;&::-webkit-scrollbar{display:none;}"]);

  var TagList = _styledComponents.default.ul.withConfig({
    displayName: "TagInput__TagList",
    componentId: "sc-48blzg-3"
  })(["", ";display:flex;"], _themes.resetList);

  var Tag = _styledComponents.default.li.withConfig({
    displayName: "TagInput__Tag",
    componentId: "sc-48blzg-4"
  })(["align-items:center;background:", ";border-radius:2px;display:flex;font-size:1.4em;height:24px;padding:0 32px 0 8px;position:relative;white-space:nowrap;button{", ";fill:", ";height:24px;line-height:0;outline:0;position:absolute;right:0;transition:background 0.2s ", ";width:24px;&:hover{background-color:", ";}box-icon{height:16px;width:16px;}}+ li{margin-left:4px;}"], function (_ref8) {
    var theme = _ref8.theme;
    return theme.colors.lightGray;
  }, _themes.resetButton, function (_ref9) {
    var theme = _ref9.theme;
    return theme.colors.darkGray;
  }, function (_ref10) {
    var theme = _ref10.theme;
    return theme.easing.ease;
  }, function (_ref11) {
    var theme = _ref11.theme;
    return (0, _polished.rgba)(theme.colors.gray, 0.4);
  });

  var Input = _styledComponents.default.input.withConfig({
    displayName: "TagInput__Input",
    componentId: "sc-48blzg-5"
  })(["border:0;flex:1;font-size:1.6em;height:40px;margin-left:4px;min-width:100%;outline:none;padding:0;&::-ms-clear{display:none;width:0;height:0;}&::-ms-reveal{display:none;width:0;height:0;}&::-webkit-search-decoration,&::-webkit-search-cancel-button,&::-webkit-search-results-button,&::-webkit-search-results-decoration{display:none;}"]);

  var Suggestions = _styledComponents.default.ul.withConfig({
    displayName: "TagInput__Suggestions",
    componentId: "sc-48blzg-6"
  })(["", ";background:", ";border:solid 1px ", ";box-shadow:0 1px 2px 0 ", ";display:", ";left:0;position:absolute;top:100%;width:100%;z-index:1;"], _themes.resetList, function (_ref12) {
    var theme = _ref12.theme;
    return theme.colors.white;
  }, function (_ref13) {
    var theme = _ref13.theme;
    return theme.colors.gray;
  }, function (_ref14) {
    var theme = _ref14.theme;
    return (0, _polished.rgba)(theme.colors.dark, 0.3);
  }, function (_ref15) {
    var active = _ref15.active;
    return active === 'true' ? 'block' : 'none';
  });

  var Loader = _styledComponents.default.div.withConfig({
    displayName: "TagInput__Loader",
    componentId: "sc-48blzg-7"
  })(["align-items:center;background:", ";border:solid 1px ", ";box-shadow:0 1px 2px 0 ", ";color:", ";display:flex;font-size:1.6em;left:0;padding:16px;position:absolute;top:100%;width:100%;z-index:1;box-icon{margin-right:8px;fill:", ";}"], function (_ref16) {
    var theme = _ref16.theme;
    return theme.colors.white;
  }, function (_ref17) {
    var theme = _ref17.theme;
    return theme.colors.gray;
  }, function (_ref18) {
    var theme = _ref18.theme;
    return (0, _polished.rgba)(theme.colors.dark, 0.3);
  }, function (_ref19) {
    var theme = _ref19.theme;
    return theme.colors.dark;
  }, function (_ref20) {
    var theme = _ref20.theme;
    return theme.colors.primary;
  });

  var NoResults = _styledComponents.default.div.withConfig({
    displayName: "TagInput__NoResults",
    componentId: "sc-48blzg-8"
  })(["background-color:", ";border:solid 1px ", ";color:", ";box-icon{fill:currentColor;height:18px;width:18px;}"], function (_ref21) {
    var theme = _ref21.theme;
    return (0, _polished.lighten)(0.4, theme.colors.red);
  }, function (_ref22) {
    var theme = _ref22.theme;
    return theme.colors.gray;
  }, function (_ref23) {
    var theme = _ref23.theme;
    return theme.colors.red;
  });

  var TagInput = function TagInput(_ref24) {
    var activeOnBlur = _ref24.activeOnBlur,
        onEditing = _ref24.onEditing,
        delimiters = _ref24.delimiters,
        onDelete = _ref24.onDelete,
        name = _ref24.name,
        placeholder = _ref24.placeholder,
        icon = _ref24.icon,
        items = _ref24.items,
        maxLength = _ref24.maxLength,
        handleAddition = _ref24.handleAddition,
        fetchSuggestions = _ref24.fetchSuggestions,
        ariaLabel = _ref24.ariaLabel,
        loadingMessage = _ref24.loadingMessage,
        noResultsMessage = _ref24.noResultsMessage,
        onlyAcceptSuggestion = _ref24.onlyAcceptSuggestion,
        error = _ref24.error,
        rest = (0, _objectWithoutPropertiesLoose2.default)(_ref24, _excluded);
    var textInput = (0, _react.useRef)(null);
    var wrapRef = (0, _react.useRef)(null);

    var _useState = (0, _react.useState)(''),
        query = _useState[0],
        setQuery = _useState[1];

    var _useState2 = (0, _react.useState)(0),
        currentSuggestion = _useState2[0],
        setCurrentSuggestion = _useState2[1];

    var _useState3 = (0, _react.useState)(false),
        activeSuggestion = _useState3[0],
        setActiveSuggestion = _useState3[1];

    var _useState4 = (0, _react.useState)(false),
        noResults = _useState4[0],
        setNoResults = _useState4[1];

    var _useState5 = (0, _react.useState)(false),
        isSearching = _useState5[0],
        setIsSearching = _useState5[1];

    var _useState6 = (0, _react.useState)([]),
        results = _useState6[0],
        setResults = _useState6[1];

    var debouncedSearchTerm = (0, _utils.useDebounce)(query, 500);

    var listRef = /*#__PURE__*/_react.default.createRef();

    var isEditing = function isEditing(value) {
      if (onEditing) {
        onEditing(value);
      }
    };

    var removeSelected = (0, _react.useCallback)(function (list) {
      return items.reduce(function (acc, d) {
        if (items.length) {
          var found = acc.filter(function (a) {
            return a.id !== d.id;
          });
          return found;
        }

        return acc;
      }, list);
    }, [items]);
    (0, _react.useEffect)(function () {
      if (debouncedSearchTerm && fetchSuggestions) {
        setIsSearching(true);
        setActiveSuggestion(false);
        fetchSuggestions(debouncedSearchTerm).then(function (res) {
          setCurrentSuggestion(0);
          setIsSearching(false);
          setResults(removeSelected(res));
          setNoResults(!removeSelected(res).length);

          if (res.length) {
            setActiveSuggestion(true);
          }
        });
      } else {
        setActiveSuggestion(false);
        setIsSearching(false);
        setResults([]);
      }
    }, [debouncedSearchTerm] // Only call effect if debounced search term changes
    );

    var handleInputChange = function handleInputChange(value) {
      var totalValue = value.length;
      var lastChar = value.substring(totalValue - 1);
      setNoResults(false);
      setQuery(value);
      isEditing(true);

      if (lastChar.match('[;,]' || lastChar === '')) {
        setQuery(value.substring(-1, totalValue - 1));
        isEditing(false);
        setActiveSuggestion(false);
        setIsSearching(false);
      }
    };

    var checkKey = function checkKey(evt) {
      return evt.key !== 'ç' && evt.key !== 'Ç' && delimiters.includes(evt.keyCode);
    };

    var resetAndFocusInput = function resetAndFocusInput() {
      setQuery('');

      if (textInput) {
        textInput.current.value = '';
        textInput.current.focus();
      }
    };

    var handleDelete = function handleDelete(i, e) {
      e.stopPropagation();
      onDelete(i, e);
      resetAndFocusInput();
      setActiveSuggestion(false);
    };

    var addTag = function addTag(item) {
      if (!item.id || !item[name]) {
        isEditing(false);
        return;
      }

      var existingKeys = items.map(function (item) {
        return item.id.toString().toLowerCase().trim();
      });

      if (existingKeys.indexOf(item.id.toString().toLowerCase().trim()) >= 0) {
        isEditing(false);
        return;
      } // call method to add


      handleAddition(item); // reset the state

      setQuery('');
      resetAndFocusInput(); // When is editing

      isEditing(false);
    };

    var buildRegExpFromDelimiters = function buildRegExpFromDelimiters() {
      var delimiterChars = delimiters.map(function (delimiter) {
        // See: http://stackoverflow.com/a/34711175/1463681
        var chrCode = delimiter - 48 * Math.floor(delimiter / 48);
        return String.fromCharCode(96 <= delimiter ? chrCode : delimiter);
      }).join('');
      var escapedDelimiterChars = (0, _lodash.escapeRegExp)(delimiterChars);
      return new RegExp("[" + escapedDelimiterChars + "]+");
    };

    var handlePaste = function handlePaste(e) {
      e.preventDefault();
      var clipboardData = e.clipboardData || window.clipboardData;
      var clipboardText = clipboardData.getData('text');
      var maxTextLength = Math.min(maxLength ? maxLength : clipboardText.length, clipboardText.length);
      var pastedText = clipboardData.getData('text').substr(0, maxTextLength); // Used to determine how the pasted content is split.

      var delimiterRegExp = buildRegExpFromDelimiters(delimiters);
      var tags = pastedText.split(delimiterRegExp);
      var tagsWithoutSpaces = tags.map(function (item) {
        return item.trim();
      });

      if (!fetchSuggestions) {
        (0, _lodash.uniq)(tagsWithoutSpaces).forEach(function (tag) {
          var _addTag;

          return addTag((_addTag = {
            id: tag
          }, _addTag[name] = tag, _addTag));
        });
      }
    };

    var handleInputKeyDown = function handleInputKeyDown(evt) {
      var totalSuggestion = results.length;

      if (evt.keyCode === KEYS.ENTER && activeSuggestion) {
        var _selectedQuery;

        var selected = results[currentSuggestion];
        var selectedQuery = (_selectedQuery = {
          id: selected.id
        }, _selectedQuery[name] = selected.descricao, _selectedQuery);
        addTag(selectedQuery);
        setQuery('');
        setActiveSuggestion(false);
      }

      if (checkKey(evt) && !onlyAcceptSuggestion && !activeSuggestion) {
        var _selectedQuery3;

        var _selectedQuery2 = (_selectedQuery3 = {
          id: query
        }, _selectedQuery3[name] = query, _selectedQuery3);

        if (query.trim() !== '') {
          addTag(_selectedQuery2);
          resetAndFocusInput();
          setActiveSuggestion(false);
        }
      }

      if (evt.keyCode === KEYS.DOWN && activeSuggestion) {
        var current = currentSuggestion === totalSuggestion - 1 ? 0 : currentSuggestion + 1;
        setCurrentSuggestion(current);
        listRef.current.scrollToItem(current);
      }

      if (evt.keyCode === KEYS.UP && activeSuggestion) {
        var _current = currentSuggestion === 0 ? totalSuggestion - 1 : currentSuggestion - 1;

        setCurrentSuggestion(_current);
        listRef.current.scrollToItem(_current);
      }

      if (items.length && evt.keyCode === KEYS.DELETE && !query.length) {
        handleDelete(items.length - 1, evt);
      }
    };

    var handleBlur = function handleBlur() {
      if (activeOnBlur && query.trim() !== '') {
        var _selectedQuery4;

        var selectedQuery = (_selectedQuery4 = {
          id: query
        }, _selectedQuery4[name] = query, _selectedQuery4);
        addTag(selectedQuery);
        setQuery('');
      }
    };

    var handleSuggestion = function handleSuggestion(value, id) {
      var _selectedQuery5;

      var selectedQuery = (_selectedQuery5 = {
        id: id
      }, _selectedQuery5[name] = value, _selectedQuery5);
      addTag(selectedQuery);
      setQuery('');
      setActiveSuggestion(false);
    };

    var onBlur = function onBlur(e) {
      if (!wrapRef.current.contains(e.relatedTarget)) {
        setActiveSuggestion(false);
        setQuery('');
        setNoResults(false);
      }
    };

    var Item = function Item(rest) {
      return /*#__PURE__*/_react.default.createElement(_Row.default, {
        handleSuggestion: handleSuggestion,
        name: name,
        currentSuggestion: currentSuggestion,
        query: query,
        rest: rest
      });
    };

    return /*#__PURE__*/_react.default.createElement(Wrap, {
      "data-testid": "TagInput",
      onBlur: onBlur,
      ref: wrapRef,
      tabIndex: "-1"
    }, /*#__PURE__*/_react.default.createElement(WrapInput, {
      htmlFor: name,
      icon: icon,
      tabIndex: "-1",
      error: error
    }, icon && /*#__PURE__*/_react.default.createElement("box-icon", {
      name: icon.name,
      type: icon.type
    }), /*#__PURE__*/_react.default.createElement(ScrollContent, {
      tabIndex: "-1"
    }, /*#__PURE__*/_react.default.createElement(TagList, null, items.map(function (item, index) {
      return /*#__PURE__*/_react.default.createElement(Tag, {
        key: item.id
      }, /*#__PURE__*/_react.default.createElement("span", null, item[name]), /*#__PURE__*/_react.default.createElement("button", {
        type: "button",
        onClick: function onClick(e) {
          return onDelete(index, e);
        }
      }, /*#__PURE__*/_react.default.createElement("box-icon", {
        name: "x",
        size: "16px"
      })));
    })), /*#__PURE__*/_react.default.createElement(Input, (0, _extends2.default)({
      "aria-autocomplete": "both",
      "aria-expanded": activeSuggestion,
      "aria-haspopup": "true",
      "aria-owns": name + "-listbox",
      "aria-activedescendant": activeSuggestion && results.length ? name + "-listbox-" + results[currentSuggestion].id : false,
      role: "combobox",
      type: "search",
      ref: textInput,
      name: name,
      id: name,
      value: query,
      onChange: function onChange(evt) {
        return handleInputChange(evt.target.value);
      },
      onPaste: handlePaste,
      onBlur: handleBlur,
      onKeyDown: handleInputKeyDown,
      tabIndex: 0,
      placeholder: placeholder,
      maxLength: maxLength,
      autoComplete: "off"
    }, rest)))), !!activeSuggestion && /*#__PURE__*/_react.default.createElement(Suggestions, {
      active: "" + activeSuggestion,
      id: name + "-listbox",
      role: "listbox",
      "aria-label": ariaLabel
    }, /*#__PURE__*/_react.default.createElement(_reactWindow.FixedSizeList, {
      className: "List",
      height: 200,
      itemCount: results.length,
      itemData: results,
      itemSize: 35,
      ref: listRef
    }, Item)), !!isSearching && /*#__PURE__*/_react.default.createElement(Loader, {
      "aria-busy": "true"
    }, /*#__PURE__*/_react.default.createElement("box-icon", {
      name: "loader-circle",
      animation: "spin"
    }), " ", loadingMessage), !!noResults && /*#__PURE__*/_react.default.createElement(Loader, {
      as: NoResults,
      "aria-busy": "true"
    }, /*#__PURE__*/_react.default.createElement("box-icon", {
      type: "solid",
      name: "info-circle"
    }), " ", noResultsMessage));
  };

  _exports.TagInput = TagInput;
  TagInput.defaultProps = {
    delimiters: [KEYS.ENTER, KEYS.COMMA, KEYS.SEMICOLON],
    items: [],
    onlyAcceptSuggestion: false
  };
});